import { Region } from '../models/enums/region.enum';

export interface RegionOption {
  value: Region;
  label: string;
}

export const REGIONS: RegionOption[] = [
  { value: Region.Europe, label: 'Europe' },
  { value: Region.America, label: 'America' },
  { value: Region.AsiaPacific, label: 'Asia Pacific' },
  { value: Region.Africa, label: 'Africa' }
];
